import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from '@reduxjs/toolkit';

import { GlobalService } from './global.service';

import { AXIOS, API, CommonGlobalService, UUID, CallbackErrorAxios, CallbackWarningAxios } from '@umanforge/common';


export class SftpService {

  static getSftpStatusOfSite(
    siteId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      AXIOS.get( `${ API.SFTP }/${ siteId }`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ active: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
            resolve( false );
            return;
          }
          resolve( response.data.active );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( false );
        } );
    } );
  }

  static getSftpErrorEmailsOfSite(
    siteId: UUID,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<string[]> {
    return new Promise( async resolve => {
      AXIOS.get( `${ API.SFTP }/${ siteId }/emails`, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ emails: string[] }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
            resolve( [] );
            return;
          }
          resolve( response.data.emails );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( [] );
        } );
    } );
  }

  static managedSftpOfSite(
    siteId: UUID, isActivated: boolean, publicKey: string | undefined,
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      const body = { isActivated, publicKey };
      AXIOS.put( `${ API.SFTP }/${ siteId }/managed`, body, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ active: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
            resolve( false );
            return;
          }
          resolve( response.status === 201 );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( false );
        } );
    } );
  }

  static addEmailForErrorSftpForSite(
    siteId: UUID, emails: string[],
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      const body = { emails };
      AXIOS.put( `${ API.SFTP }/${ siteId }/add_email`, body, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ active: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
            resolve( false );
            return;
          }
          resolve( response.status === 201 );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( false );
        } );
    } );
  }

  static removeEmailForErrorSftpForSite(
    siteId: UUID, emails: string[],
    token: string | null, dispatch: Dispatch,
    onError?: CallbackErrorAxios, onWarning?: CallbackWarningAxios
  ): Promise<boolean> {
    return new Promise( async resolve => {
      const body = { emails };
      AXIOS.put( `${ API.SFTP }/${ siteId }/remove_email`, body, await CommonGlobalService.getHeaderRequest( token ) )
        .then( ( response: AxiosResponse<{ active: boolean }> ) => {
          CommonGlobalService.saveRequestToken( response, dispatch );
          if ( response.status === 202 ) {
            GlobalService.onAxiosWarning( response, onWarning );
            resolve( false );
            return;
          }
          resolve( response.status === 201 );
        } )
        .catch( ( err: AxiosError ) => {
          GlobalService.onAxiosError( err, dispatch, onError );
          resolve( false );
        } );
    } );
  }

};